import React, { Component } from 'react';
import { withRouter } from 'react-router';
import NoImage from '../SVGs/noImage';
import Card from '../components/card';
import BackButton from '../components/backButton';
import MapButton from '../components/mapButton';
import OpenIndicator from '../components/openIndicator';
import fetchAllOutlets from '../data/outletsAPI';
export class OutletView extends Component {
  state = {
    loading: true
  };

  async componentDidMount() {
    const { location } = this.props;

    if (location.data) {
      window.location.href = `/itpi/lighthouse/outlets/${
        location.data.businessID
      }}`;
    } else {
      const id = location.pathname.substring(1, location.pathname.length);
      window.location.href = `/itpi/lighthouse/outlets/${id}}`;
    }

    if (location.data) {
      this.setState({ loading: false, ...location.data });
    } else {
      const id = location.pathname.substring(1, location.pathname.length);

      await fetchAllOutlets().then(response => {
        const outlets = response.filter(outlet => outlet.businessID === id);

        this.setState({ loading: false, ...outlets[0] });
      });
    }
  }
  

  renderOpeningTimes() {
    const { openingHours } = this.state;
    const days = [];
    const openingTimes = [];

    openingHours.daysOfWeek.forEach(day => {
      days.push(
        <div key={day.day} style={{ paddingBottom: 5 }}>
          <p>{day.day}: </p>
        </div>
      );

      if (day.closed) {
        openingTimes.push(
          <div key={day.day} style={{ paddingBottom: 5 }}>
            <p>Closed</p>
          </div>
        );
      } else {
        const openTimeString = `${day.openFrom ? day.openFrom : 'Unknown'} - ${
          day.openTo ? day.openTo : 'Unknown'
        }`;

        openingTimes.push(
          <div key={day.day} style={{ paddingBottom: 5 }}>
            <p>{openTimeString}</p>
          </div>
        );
      }
    });

    const display = (
      <div style={{ display: 'flex', fontSize: '19px' }}>
        <div
          style={{ display: 'flex', flexDirection: 'column', paddingRight: 15 }}
        >
          {days}
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            padding: '0px 5px'
          }}
        >
          {openingTimes}
        </div>
      </div>
    );
    return display;
  }

  renderImage() {
    const { imageURL, shortDescription } = this.state;
    let imageElement;
    if (imageURL.includes('no_image') || !imageURL.length) {
      imageElement = <div style={{ padding: 15 }}>{NoImage}</div>;
    } else {
      imageElement = (
        <img
          src={imageURL}
          alt={shortDescription}
          style={{ maxWidth: '100%' }}
        />
      );
    }

    return <div style={{ zIndex: 1 }}>{imageElement}</div>;
  }

  renderHeader() {
    const { name } = this.state;
    return (
      <div
        style={{
          position: 'absolute',
          bottom: 4,
          width: '100%',
          zIndex: 2
        }}
      >
        <h2>
          <span
            style={{
              color: 'white',
              background: 'rgba(0, 0, 0, 0.6)',
              padding: '2px 10px',
              fontSize: '28px',
              marginRight: 15
            }}
          >
            {name}
          </span>
        </h2>
      </div>
    );
  }

  renderContactInfo() {
    const { websiteURL, telephone } = this.state;
    let website = null;

    let phone = null;

    if (websiteURL.length > 0) {
      const websiteToDisplay = websiteURL.replace(
        /^(?:https?:\/\/)?(?:www\.)?/i,
        ''
      );

      website = (
        <p
          style={{
            textTransform: 'uppercase',
            letterSpacing: '1px',
            fontSize: '11px',
            maxWidth: '50%',
            overflowX: 'hidden'
          }}
        >
          <a href={websiteURL}>{websiteToDisplay}</a>
        </p>
      );
    }

    if (telephone.length > 0) {
      phone = (
        <p
          style={{
            textTransform: 'uppercase',
            letterSpacing: '1px',
            fontSize: '11px'
          }}
        >
          <a href={`tel:${telephone}`}>{telephone}</a>
        </p>
      );
    }

    return (
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between'
        }}
      >
        {website}
        {phone}
      </div>
    );
  }

  renderTags() {
    const { tags } = this.state;
    const tagList = [];

    tags.forEach(tag => {
      tagList.push(
        <div
          style={{
            padding: 5,
            textTransform: 'uppercase',
            fontFamily: 'aktivgrotesklight',
            letterSpacing: 1,
            fontSize: 13,
            color: 'rgba(229, 249, 255, 1)',
            background: 'rgba(0, 99, 130, 1)',
            borderRadius: 2,
            margin: 5,
            width: 'fit-content'
          }}
        >
          <span style={{ lineHeight: '17px' }}>{tag.trim()}</span>
        </div>
      );
    });

    return tagList;
  }

  render() {
    window.scrollTo(0, 0);
    const {
      loading,
      isOpen,
      shortDescription,
      description,
      openingHours,
      tags
    } = this.state;
    let descriptionToRender = `There is no description for this outlet.`;

    if (loading) {
      return <h2>loading</h2>;
    }
    if (description.length > 0) {
      descriptionToRender = description;
    } else if (shortDescription.length > 0) {
      descriptionToRender = shortDescription;
    }

    // Uncomment this and {mazeMap}
    // if(enableMazeMapSyscode === true){
    //   if(syscode){
    //     mazeMap = (<div style={buttonStyle}><a style={{ color: 'rgba(229, 249, 255, 1)' }} href={`https://use.mazemap.com/?campusid=343&desttype=point&dest=${longitude},${latitude}`}>View on map <FaMapMarker/></a></div>);
    //   } else if(longitude && latitude){
    //     mazeMap = (<div style={buttonStyle}><a style={{ color: 'rgba(229, 249, 255, 1)' }} href={`https://use.mazemap.com/?campusid=343&desttype=point&dest=${longitude},${latitude}`}>View on map <FaMapMarker/></a></div>);
    //   }
    // } else if(longitude && latitude){
    //   mazeMap = (<div style={buttonStyle}><a style={{ color: 'rgba(229, 249, 255, 1)' }} href={`https://use.mazemap.com/?campusid=343&desttype=point&dest=${longitude},${latitude}`}>View on map <FaMapMarker/></a></div>);
    // }

    const { location } = this.props; // should this be on mount
    const businessID = location.pathname.substring(1, location.pathname.length);
    return (
      <div style={{ backgroundColor: '#e6e6e6', minHeight: '100%' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            height: '100%',
            padding: 15
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              alignItems: 'flex-start',
              width: '100%',
              maxWidth: '900px'
            }}
          >
            <div
              style={{
                display: 'flex',
                justifycontent: 'space-between',
                flexDirection: 'row',
                flexWrap: 'wrap',
                alignItems: 'flex-start',
                marginBottom: '15px',
                width: '80%'
              }}
            >
              <BackButton />
            </div>
            <div
              style={{
                display: 'flex',
                float: 'right',
                justifycontent: 'space-between',
                flexDirection: 'row',
                flexWrap: 'wrap',
                alignItems: 'flex-end',
                marginBottom: '15px',
                width: '20%'
              }}
            >
              <MapButton businessID={businessID} />
            </div>

            <Card
              styles={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'space-between',
                marginBottom: 15,
                marginRight: 15,
                width: '100%',
                maxWidth: '500px'
              }}
            >
              <div
                style={{
                  width: '100%',
                  position: 'relative'
                }}
              >
                {this.renderImage()}
                {this.renderHeader()}
              </div>

              <div style={{ padding: 15 }}>
                <div style={{ marginBottom: 15 }}>
                  <OpenIndicator openingHours={openingHours} isOpen={isOpen} />
                </div>

                <p style={{ fontSize: '19px' }}>{descriptionToRender}</p>
                <div style={{ marginTop: 15 }}>{this.renderContactInfo()}</div>
                {/* {mazeMap} */}
              </div>
            </Card>

            <Card styles={{ padding: 15, marginBottom: 15 }}>
              <h3 style={{ marginTop: 0 }}>Opening Times This Week</h3>
              <div>{this.renderOpeningTimes()}</div>
            </Card>

            {tags.length > 0 ? (
              <Card
                styles={{
                  padding: 15,
                  maxWidth: '350px',
                  maxHeight: '400px',
                  overflowY: 'scroll',
                  marginBottom: '15px'
                }}
              >
                <h3 style={{ marginTop: 0 }}>
                  Tags <span>({tags.length})</span>
                </h3>
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                  {this.renderTags()}
                </div>
              </Card>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(OutletView);
